/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TableIconBadge from './TableIconBadge';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { BiRightArrow, BiDownArrow } from 'react-icons/bi';
import AppContext from 'context/Context';
import { useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import { getTenantFromToken } from 'utils/routeUtils';

const ProjectNameCell = ({ row, onEvaluateClick, onMonitoringClick }) => (
  <Dropdown drop="right">
    <Dropdown.Toggle
      disabled
      style={{ cursor: 'pointer', fontWeight: 500 }}
      as={'span'}
    >
      <span>{row.project_name}</span>
    </Dropdown.Toggle>

    <Dropdown.Menu>
      {/* <Dropdown.Item onClick={() => onEvaluateClick(row)}>
        Evaluation
      </Dropdown.Item> */}
      {row.monitoring_status === true && (
        <Dropdown.Item onClick={() => onMonitoringClick(row)}>
          Monitoring
        </Dropdown.Item>
      )}
    </Dropdown.Menu>
  </Dropdown>
);

const ForwardRefFontAwesomeIcon = React.forwardRef((props, ref) => (
  <FontAwesomeIcon {...props} forwardedRef={ref} className="my-2" />
));

const ActionCell = ({
  row,
  onViewClick,
  onUpdateClick,
  onDeleteClick,
  onStartProcessClick
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStartProcessModal, setShowStartProcessModal] = useState(false);

  const isEditable =
    row.status && row.status?.toLowerCase() !== 'Processing'.toLowerCase();
  const isProcessable =
    row.status && row.status?.toLowerCase() === 'New'.toLowerCase();

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = () => {
    onDeleteClick(row);
    handleCloseDeleteModal();
  };

  const handleCloseStartProcessingModal = () => {
    setShowStartProcessModal(false);
  };

  const handleConfirmStartProcessing = () => {
    onStartProcessClick(row);
    handleCloseStartProcessingModal();
  };

  return (
    <>
      <Dropdown drop="left">
        <Dropdown.Toggle
          style={{ cursor: 'pointer' }}
          as={ForwardRefFontAwesomeIcon}
          icon="ellipsis-v"
          pull="right"
        />

        <Dropdown.Menu>
          <Dropdown.Item onClick={() => onViewClick(row)}>View</Dropdown.Item>
          {/* {isEditable && (
            <Dropdown.Item onClick={() => onUpdateClick(row)}>
              Edit
            </Dropdown.Item>
          )} */}
          {isEditable && (
            <Dropdown.Item onClick={() => setShowDeleteModal(true)}>
              Delete
            </Dropdown.Item>
          )}
          {isProcessable && (
            <Dropdown.Item onClick={() => setShowStartProcessModal(true)}>
              Start Process
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>

      {isEditable && (
        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
          <Modal.Header closeButtonc className="border-0">
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete {row.project_name}?
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="light" onClick={handleCloseDeleteModal}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmDelete}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {isProcessable && (
        <Modal
          show={showStartProcessModal}
          onHide={handleCloseStartProcessingModal}
          centered
          className="p-5"
        >
          <Modal.Header closeButtonc className="border-0">
            <Modal.Title>Confirm Start Processing</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to start processing for {row.project_name}?
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="light" onClick={handleCloseStartProcessingModal}>
              Cancel
            </Button>
            <Button variant="success" onClick={handleConfirmStartProcessing}>
              Start Processing
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

ActionCell.propTypes = {
  row: PropTypes.object.isRequired,
  onViewClick: PropTypes.func.isRequired,
  onUpdateClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onStartProcessClick: PropTypes.func.isRequired
};

const ManageProjectsTable = ({
  data,
  deletePorjectAPI,
  startProcessingAPI
}) => {
  const tenant = getTenantFromToken();
  const navigate = useNavigate();

  const handleNavigate = (projectName, page) => {
    const projectNameSnakeCase = projectName.toLowerCase().replace(/\s+/g, '_');
    navigate(`/${tenant}/${page}/${projectNameSnakeCase}`);
  };

  const columns = [
    // {
    //   id: 'expander', // Make sure it has an ID
    //   Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
    //     <span {...getToggleAllRowsExpandedProps()}>
    //       {isAllRowsExpanded ? <BiDownArrow /> : <BiRightArrow />}
    //     </span>
    //   ),
    //   Cell: ({ row }) =>
    //     row.canExpand ? (
    //       <span
    //         {...row.getToggleRowExpandedProps({
    //           style: {
    //             paddingLeft: `${row.depth * 2}rem`
    //           }
    //         })}
    //       >
    //         {row.isExpanded ? <BiDownArrow /> : <BiRightArrow />}
    //       </span>
    //     ) : null
    // },
    {
      accessor: 'project_name',
      Header: 'Project Name',
      Cell: ({ value, row }) => {
        const status = row.original.status;
        if (
          status.toLowerCase() === 'completed' ||
          status.toLowerCase() === 'processing'
        ) {
          return (
            <ProjectNameCell
              row={row.original}
              // onEvaluateClick={row =>
              //   handleNavigate(row.request_id, 'evaluate')
              // }
              onMonitoringClick={row =>
                handleNavigate(row.request_id, 'monitor')
              }
            />
          );
        }
        return value;
      }
    },
    {
      accessor: 'country',
      Header: 'Country'
    },
    {
      accessor: 'state',
      Header: 'State'
    },
    {
      accessor: 'project_area',
      Header: 'Project Area'
    },
    {
      accessor: 'status',
      Header: 'Status',
      Cell: ({ value }) => {
        switch (value.toString().toLowerCase()) {
          case 'new':
            return (
              <TableIconBadge title="New" type="primary" icon={faLayerGroup} />
            );
          case 'queued':
            return (
              <TableIconBadge title="Queued" type="warning" icon="clock" />
            );
          case 'processing':
            return (
              <TableIconBadge title="Processing" type="info" icon="spinner" />
            );
          case 'completed':
            return (
              <TableIconBadge title="Completed" type="success" icon="check" />
            );
          case 'rejected':
            return (
              <TableIconBadge title="Rejected" type="danger" icon="times" />
            );
          default:
            return value;
        }
      }
    },
    {
      accessor: 'created_on',
      Header: 'Created On'
    },
    {
      accessor: 'updated_on',
      Header: 'Updated On'
    },
    {
      accessor: 'monitoring_status',
      Header: 'Monitoring Enabled',
      Cell: ({ value }) => {
        if (value === true) {
          return <TableIconBadge title="Yes" type="success" icon="check" />;
        } else {
          return <TableIconBadge title="No" type="danger" icon="times" />;
        }
      }
    },
    {
      accessor: '',
      Header: 'Action',
      disableSortBy: true,
      Cell: ({ row }) => (
        <ActionCell
          row={row.original}
          onViewClick={row => navigate(`/${tenant}/projects/${row.request_id}`)}
          onUpdateClick={row =>
            navigate(`/${tenant}/projects/${row.request_id}/edit`)
          }
          onDeleteClick={row =>
            deletePorjectAPI.request({
              tenant: tenant,
              request_id: row.request_id
            })
          }
          onStartProcessClick={row =>
            startProcessingAPI.request({
              tenant: tenant,
              request_id: row.request_id
            })
          }
        />
      )
    }
  ];

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      pagination
      sortable
      perPage={25}
      className="min-vh-50 py-5"
    >
      <AdvanceTable
        table
        headerClassName="bg-200 text-900 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
          pageSize={25}
        />
      </div>
    </AdvanceTableWrapper>
  );
};

ManageProjectsTable.propTypes = {
  data: PropTypes.array.isRequired,
  deletePorjectAPI: PropTypes.object.isRequired,
  startProcessingAPI: PropTypes.object.isRequired
};

AdvanceTableWrapper.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      accessor: PropTypes.string,
      Header: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      Cell: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({
          value: PropTypes.func.isRequired,
          row: PropTypes.shape({
            original: PropTypes.object.isRequired
          }).isRequired
        })
      ])
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  pagination: PropTypes.bool,
  perPage: PropTypes.number
};

export default ManageProjectsTable;
